import * as React from 'react'
import { type ClassicScheme, type Presets } from 'rete-react-plugin'
import { IdsProvider } from '@instacart/ids-core'
import { IntlProvider } from 'react-intl'
import { SHARED_COMPONENTS_EN_US } from '@retailer-platform/shared-components'
import { TdsProvider } from '@retailer-platform/shared-components/src/tds'
import EN_US from '../../../../../../src/translations/en-US.json'
import { type PipelineEditorStepNodeInterface } from '../rete/nodes.tsx'
import { PipelineEditorNode } from './PipelineEditorNode.tsx'

interface CustomScheme extends ClassicScheme {
  Node: PipelineEditorStepNodeInterface
}

interface Props<S extends CustomScheme> {
  data: S['Node']
  emit: Presets.classic.RenderEmit<S>
}

/**
 * The purpose of this component is to create all the providers we have in IPP.
 */
export function PipelineEditorNodeContainer<S extends CustomScheme>(props: Props<S>) {
  return (
    <TdsProvider>
      <IdsProvider>
        <IntlProvider locale="en-US" messages={{ ...SHARED_COMPONENTS_EN_US, ...EN_US }}>
          <PipelineEditorNode emit={props.emit} data={props.data} />
        </IntlProvider>
      </IdsProvider>
    </TdsProvider>
  )
}
